module.exports = __webpack_public_path__ + "static/media/japan(1).859c96a8.svg";